/**
 * SDK del Módulo Portafolio — Sistema de Perfiles ConstruLink.
 *
 * Todos los endpoints están montados bajo `/api/perfil/portafolio`.
 * Los adjuntos (imágenes/documentos) se sirven autenticadamente por el
 * backend. Para <img src> usamos `fetchAdjuntoBlob` que descarga como blob
 * y crea un ObjectURL local — no hay tokens en la URL.
 */

import { api, getStoredToken } from "./api";

export const CATEGORIAS_PORTAFOLIO_FALLBACK = [
  { codigo: "trabajo", etiqueta: "Trabajo realizado" },
  { codigo: "fotografia", etiqueta: "Fotografía" },
  { codigo: "documento", etiqueta: "Documento" },
  { codigo: "certificado", etiqueta: "Certificado" },
  { codigo: "video", etiqueta: "Video" },
  { codigo: "otro", etiqueta: "Otro" },
];

export const LIMITE_TAMANO_MB = 25;
export const LIMITE_ADJUNTOS_POR_ITEM = 8;

export async function fetchCategorias() {
  const { data } = await api.get("/perfil/portafolio/categorias");
  return data;
}

export async function fetchPortafolio() {
  const { data } = await api.get("/perfil/portafolio");
  return data;
}

export async function fetchPortafolioDeUsuario(userId) {
  const { data } = await api.get(`/perfil/portafolio/usuario/${userId}`);
  return data;
}

export async function crearItem(payload) {
  const { data } = await api.post("/perfil/portafolio", payload);
  return data;
}

export async function actualizarItem(id, patch) {
  const { data } = await api.put(`/perfil/portafolio/${id}`, patch);
  return data;
}

export async function eliminarItem(id) {
  await api.delete(`/perfil/portafolio/${id}`);
}

export async function reordenarItems(ids) {
  const { data } = await api.post("/perfil/portafolio/reordenar", { ids });
  return data;
}

export async function subirAdjunto(itemId, file, onProgress) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post(
    `/perfil/portafolio/${itemId}/adjuntos`,
    form,
    {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (evt) => {
        if (onProgress && evt.total) {
          onProgress(Math.round((evt.loaded / evt.total) * 100));
        }
      },
    }
  );
  return data;
}

export async function eliminarAdjunto(adjuntoId) {
  await api.delete(`/perfil/portafolio/adjuntos/${adjuntoId}`);
}

/**
 * Descarga un adjunto y devuelve un ObjectURL para usar en <img src>.
 * El caller es responsable de llamar `URL.revokeObjectURL(url)` al desmontar.
 */
export async function fetchAdjuntoBlob(urlRelativa) {
  const base = process.env.REACT_APP_BACKEND_URL || "";
  const token = getStoredToken();
  const res = await fetch(`${base}${urlRelativa}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) throw new Error(`No se pudo cargar el archivo (${res.status})`);
  const blob = await res.blob();
  return URL.createObjectURL(blob);
}
